import React, { Fragment } from 'react';
import { useTranslate } from 'react-admin';

import Grid from '@material-ui/core/Grid';

import { TextField, AmountField, GlTypeLabel } from '~/components';
import { TextField as RaTextField } from '~/components/ra';
import { l } from '~/resources/pricings/PricingShow';
import { useDiffClassFor } from '~/hooks/useDraftDiffContext';
import { PricingFeeType } from '~/api/pricings';
import { useAccountEntity } from '~/hooks/accounts';

const FeeField = (props: any) => {
  const { record = {}, tax } = props;
  const translate = useTranslate();
  const t = (key: string, variant: number = 1): string => translate(l(key), variant);
  const { data: pnlAccount } = useAccountEntity(record.pnlAccountId);
  const diffClass = useDiffClassFor();
  return (
    <Fragment>
      <Grid item xs={4}>
        <TextField label={tax ? t('taxType') : t('feeType')} className={diffClass('type')}>
          {record.type && t(record.type)}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        <TextField label={t('statementTitle')} className={diffClass('name')}>
          {record.name}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        {record.pnlAccountId ? (
          <TextField label={t('pnlAccount')} ellipsis className={diffClass('pnlAccountId')}>
            <GlTypeLabel glType={pnlAccount?.glType} text={pnlAccount?.alias} />
          </TextField>
        ) : (
          <RaTextField label={t('pnlAccount')} allowEmpty />
        )}
      </Grid>
      {(() => {
        switch (record.type as PricingFeeType | undefined) {
          case 'fixedDebitFee':
          case 'fixedCreditFee':
            return (
              <Grid item xs={4}>
                <TextField label={t('amount')} className={diffClass('amount')}>
                  <AmountField amount={record.amount} />
                </TextField>
              </Grid>
            );
          case 'percentDebitFee':
          case 'percentCreditFee':
            return (
              <Fragment>
                <Grid item xs={4}>
                  <TextField label={t('percent', 2)} className={diffClass('percent')}>
                    {record.percent?.toString() && `${record.percent}%`}
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField label={t('minAmount')} className={diffClass('minAmount')}>
                    <AmountField amount={record.minAmount} />
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField label={t('maxAmount')} className={diffClass('maxAmount')}>
                    <AmountField amount={record.maxAmount} />
                  </TextField>
                </Grid>
              </Fragment>
            );
          case 'fixedPlusPercentDebitFee':
          case 'fixedPlusPercentCreditFee':
            return (
              <Fragment>
                <Grid item xs={4}>
                  <TextField label={t('amount')} className={diffClass('amount')}>
                    <AmountField amount={record.amount} />
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField label={t('percent', 2)} className={diffClass('percent')}>
                    {record.percent?.toString() && `${record.percent}%`}
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField label={t('minAmountOfPercentPart')} className={diffClass('minAmount')}>
                    <AmountField amount={record.minAmount} />
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField label={t('maxAmountOfPercentPart')} className={diffClass('maxAmount')}>
                    <AmountField amount={record.maxAmount} />
                  </TextField>
                </Grid>
              </Fragment>
            );
          default:
            return null;
        }
      })()}
      {(record.index || record.index === 0) && (
        <Grid item xs={4}>
          <TextField label={t('index')} className={diffClass('index')}>
            {record.index}
          </TextField>
        </Grid>
      )}
    </Fragment>
  );
};

const DefaultFeeView = (props: any) => {
  const { record, tax } = props;
  return (
    <Grid item container spacing={2}>
      <FeeField record={record} tax={tax} />
    </Grid>
  );
};

export default DefaultFeeView;
